import { FontConfig, PresetColors } from './types';

export const FONT_OPTIONS: Array<FontConfig> = [
    { name: 'Georgia', value: 'Georgia, serif', category: 'serif' },
    {
        name: 'Times New Roman',
        value: "'Times New Roman', serif",
        category: 'serif',
    },
    { name: 'Garamond', value: 'Garamond, serif', category: 'serif' },
    { name: 'Arial', value: 'Arial, sans-serif', category: 'modern' },
    {
        name: 'Helvetica',
        value: 'Helvetica, sans-serif',
        category: 'modern',
    },
    {
        name: 'Calibri',
        value: 'Calibri, sans-serif',
        category: 'modern',
    },
    {
        name: 'Verdana',
        value: 'Verdana, sans-serif',
        category: 'modern',
    },
];

export const PRESET_COLORS: Array<PresetColors> = [
    // Neutros — a escolha institucional: baixa saturação, nenhuma leitura de humor.
    { group: 'Neutros', name: 'Grafite', primary: '#2F343A', secondary: '#96A0AA' },
    { group: 'Neutros', name: 'Ardósia', primary: '#5A626E', secondary: '#AEB6C2' },
    { group: 'Neutros', name: 'Areia', primary: '#736758', secondary: '#BCB0A0' },
    // Azuis
    { group: 'Azuis', name: 'Marinho', primary: '#16355E', secondary: '#7A99BE' },
    { group: 'Azuis', name: 'Cobalto', primary: '#2264BC', secondary: '#7DAEE4' },
    { group: 'Azuis', name: 'Petróleo', primary: '#0F5E6B', secondary: '#5CA6B2' },
    // Verdes
    { group: 'Verdes', name: 'Floresta', primary: '#1E5038', secondary: '#72AB8E' },
    { group: 'Verdes', name: 'Sálvia', primary: '#556B5B', secondary: '#A3BCA9' },
    { group: 'Verdes', name: 'Oliva', primary: '#616629', secondary: '#B0B570' },
    // Terrosos
    { group: 'Terrosos', name: 'Terracota', primary: '#9E4520', secondary: '#E0956B' },
    { group: 'Terrosos', name: 'Ocre', primary: '#875F17', secondary: '#D8A44E' },
    { group: 'Terrosos', name: 'Café', primary: '#4F3A30', secondary: '#AD8F80' },
    // Vinhos
    { group: 'Vinhos', name: 'Bordô', primary: '#8B2440', secondary: '#C8768C' },
    { group: 'Vinhos', name: 'Ameixa', primary: '#5D3A6B', secondary: '#A78BB4' },
    { group: 'Vinhos', name: 'Violeta', primary: '#4A3FB0', secondary: '#948CDE' },
];

/**
 * Render order of the color families. The picker grid is three columns wide, so
 * every group is exactly three schemes — one labelled row each.
 */
export const PRESET_COLOR_GROUPS = ['Neutros', 'Azuis', 'Verdes', 'Terrosos', 'Vinhos'] as const;
